export default class Constants {
    public static readonly PRODUCTION: string = "production";
    public static readonly ENV_CONFIG_FILENAME: string = "env-config.json";
    public static readonly APP_NAME: string = "BaseCamp";

    public static readonly ADMINISTRATOR: string = "Administrator";

    public static readonly ROLES = {
        BASIC_USER: "basic",
        SHIFT_LEADER: "shift_leader",
        MANAGER: "manager",
        SUPERUSER: "superuser"
    };
}



// WEBPACK FOOTER //
// ./src/Constants/Constants.tsx